import { render } from "./JobsWrapper.vue?vue&type=template&id=99383390"
import script from "./JobsWrapper.vue?vue&type=script&lang=js"
export * from "./JobsWrapper.vue?vue&type=script&lang=js"

import "./JobsWrapper.vue?vue&type=style&index=0&id=99383390&lang=css"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__